export class GetAgreementsResponse {
    'agreements';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "agreements",
            "baseName": "agreements",
            "type": "Array<AgreementWithCredits>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetAgreementsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
